export default "/images/d75a4fee55907f61d641e75bca49f846.avif";